var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 2.66666C8.65366 2.66666 2.66699 8.65332 2.66699 16C2.66699 23.3467 8.65366 29.3333 16.0003 29.3333C23.347 29.3333 29.3337 23.3467 29.3337 16C29.3337 8.65332 23.347 2.66666 16.0003 2.66666ZM22.3737 12.9333L14.8137 20.4933C14.627 20.68 14.3737 20.7867 14.107 20.7867C13.8403 20.7867 13.587 20.68 13.4003 20.4933L9.62699 16.72C9.24033 16.3333 9.24033 15.6933 9.62699 15.3067C10.0137 14.92 10.6537 14.92 11.0403 15.3067L14.107 18.3733L20.9603 11.52C21.347 11.1333 21.987 11.1333 22.3737 11.52C22.7603 11.9067 22.7603 12.5333 22.3737 12.9333Z",
    fill: "#439745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.2c5c637ed6f57b9e274832a59c5443bf.svg";
export { ForwardRef as ReactComponent };